<template>
  <div
    v-if="labels && labels?.length > 0"
    class="d-flex flex-wrap f6 text-secondary"
  >
    <span
      v-for="label in labels"
      :key="label?.id"
      class="d-flex align-items-center badge badge-pill mr-1 mb-1"
      :style="{ 
        'background-color': '#' + label?.hexColor}"
    >
      <span
        class="gf-adaptate-color repo-list-label"
        v-truncate-text="15"
      >
        {{ label?.title }}
      </span>
      <i
        v-if="deletable"
        class="gf-icon gf-icon-x cursor-pointer gf-adaptate-color repo-list-icon"
        @click="$emit('delete', label)"
      />
    </span>
    <empty-listing
      v-if="!!labels && !labels?.length"
      :title="$tc('message.label', 3)"
    />
  </div>
</template>

<script>
import EmptyListing from '@shared/shared-components/empty-listing';
import { truncateTextDirective } from '@/directives';

export default {
  name: 'RepoLabelList',
  components: { EmptyListing },
  directives: { truncateText: truncateTextDirective },
  props: {
    labels: {
      default: null
    },
    deletable: {
      default: false
    }
  },
  watch: {
    labels: {
      handler() {
        this.$nextTick(() => { // Для отрабатывания скрипта только после того, как лейбл был отрисован на странице
          calculateParentBackground(); // функция из scripts.js
        });
      },
      immediate: true // Для отрабатывания скрипта, при первичной отрисовке лейблов на странице (т.е. до мутаций пропсов)
    }
  }
};
</script>

<style lang="scss">
$this: '.repo-list';
#{$this} {
  &-icon {
    font-size: 12px !important;
  }

  &-label {
    font-size: 10px;
  }
}
</style>
